(() => {
  const slug = (value) => value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
    .replace(/^-+|-+$/g, '');

  const uniqueId = (heading, index, used) => {
    const base = heading.id || slug(heading.textContent || '') || `section-${index + 1}`;
    let candidate = base;
    let suffix = 2;
    while (used.has(candidate) || (document.getElementById(candidate) && document.getElementById(candidate) !== heading)) {
      candidate = `${base}-${suffix}`;
      suffix += 1;
    }
    used.add(candidate);
    return candidate;
  };

  const wrapTables = (root) => {
    root.querySelectorAll('table').forEach((table) => {
      if (table.parentElement?.matches('[data-page-table-scroll]')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'page-table-scroll';
      wrapper.dataset.pageTableScroll = '';
      table.before(wrapper);
      wrapper.append(table);
    });
  };

  const initPage = (root) => {
    if (root.dataset.staticPageBound === 'true') return;
    root.dataset.staticPageBound = 'true';

    const content = root.querySelector('.service-layout__main');
    const aside = root.querySelector('[data-page-toc]');
    const list = root.querySelector('[data-page-toc-list]');
    if (!content) return;

    wrapTables(content);
    if (!aside || !list) return;

    const used = new Set();
    const headings = [...content.querySelectorAll('h2, h3')]
      .filter((heading) => heading.textContent.trim() && !heading.closest('[hidden]'));
    if (headings.length < 2) return;

    const links = headings.map((heading, index) => {
      heading.id = uniqueId(heading, index, used);
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.dataset.level = heading.tagName.slice(1);
      list.append(link);
      return link;
    });

    const setActive = (heading) => {
      links.forEach((link) => {
        const active = link.getAttribute('href') === `#${heading.id}`;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };

    setActive(headings[0]);
    aside.hidden = false;

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((left, right) => left.boundingClientRect.top - right.boundingClientRect.top);
      if (visible[0]) setActive(visible[0].target);
    }, { rootMargin: '-20% 0px -65% 0px', threshold: [0, 1] });
    headings.forEach((heading) => observer.observe(heading));
  };

  const init = (scope = document) => scope
    .querySelectorAll('[data-static-page]')
    .forEach((root) => initPage(root));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
